// Meta Pixel integration for Axe IA Tech
// Pixel ID: 1585464552773631
const PIXEL_ID = '1585464552773631'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the official Meta Pixel base code and initializes the pixel.
 * Safe to call multiple times — it only initializes once.
 * Wrapped in try/catch so a pixel failure can NEVER break the app render.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      f.fbq = n
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const head = b.head || b.getElementsByTagName('head')[0]
      const firstScript = b.getElementsByTagName(e)[0]
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript)
      } else if (head) {
        head.appendChild(t)
      } else {
        b.documentElement.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  } catch (err) {
    // Never let analytics break the page.
    console.error('Meta Pixel init failed:', err)
  }
}

/** Fires a PageView event (use on client-side route changes). */
export function trackPageView(): void {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'PageView')
  } catch (err) {
    console.error('Meta Pixel PageView failed:', err)
  }
}

/** Fires an arbitrary standard/custom Meta Pixel event. */
export function trackEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', event, params)
  } catch (err) {
    console.error('Meta Pixel event failed:', err)
  }
}
